import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import Tabs from 'react-responsive-tabs'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { Button, Col, Row } from 'reactstrap'

import Tab from './tab'
import { checkIsAdminOrManager, cms, editCMS, tidyName } from '../helper'
import { fetchUpdateApiData, setDomain, setDropdownOptionsByPage, submitRequest } from '../Redux/Reducers/CMS'
import Icon from '../CMSComponent/icon'
import ConfirmButton from './Common/confirmButton'
import { removeItemByName } from '../Redux/Reducers/CMS'
import EditTabPage from './EditCMS/ContentForms/editTabPage'
import IconSet from '../CMSComponent/icon'
import SetTabOrder from './EditCMS/ContentForms/setTabOrder'
import AddGridData from './Grid/Component/AddGridData/addGridData'
import AddNewTabOnPage from './EditCMS/ContentForms/addTabHere'
import ApproveJobsQuestionnaire from '../Components/PageSpecificComponents/ApproveJobs/approveJobsQuestionnaire'
import SecurityTab from '../Pages/UserSecurity/securityTab'
import Permission from '../Pages/Permission/permission'
import PageTitle from '../Layout/AppMain/pageTitle'
import UserPermission from '../Pages/Permission/UserPermission/userPermission'
import SelectDomainField from './Common/selectDomain'
import RCTabs from '../Components/Tabs/rcTabs'
import EditPurchase from '../Components/PageSpecificComponents/Purchase/editPurchase'
import MoveBooking from '../Components/PageSpecificComponents/Purchase/MoveBooking/moveBooking'
import RefundLogs from '../Components/PageSpecificComponents/Refund/Logs/refundLogs'
import NotesTable from '../Components/PageSpecificComponents/PlannedBlock/notes/notes'
import VoucherTable from '../Components/PageSpecificComponents/PlannedBlock/Voucher/voucherTable'
import DomainLogs from '../Components/PageSpecificComponents/PlannedBlock/Logs/domainLogs'
import { useLockerYearContext } from '../Context/lockerYearContext'
import { request } from '../Redux/Sagas/requests/api'
import RenewalLogs from '../Components/PageSpecificComponents/LockerYear/Logs/renewalLogs'
import EditTicket from '../Components/PageSpecificComponents/RaiseTicket/EditTicket/editTicket'
import QueryTypeLog from '../Components/PageSpecificComponents/RaiseTicket/Logs/queryTypeLog'

// import 'react-responsive-tabs/styles.css'

const securityTabs = ['security_messages', 'security_contractors', 'security_templates', 'security_items', 'security_domains']

const GetTabTitle = ({ progressData, tab, currentRow, logsCount }) => {
  if (tab?.is_grid) {
    if (tab?.show_data_progress && false) {
      if (progressData?.[tab?.name]?.count_int > 0) {
        return (
          <div className='subtitle1' onClick={() => editCMS(tab.cms_tab_key)}>
            {cms(tab.cms_tab_key)}{' '}
            <span className='bg-success ml-2' style={{ padding: '1px 10px', borderRadius: '20px' }}>
              <i class='fa-solid fa-check '></i>
            </span>
          </div>
        )
      } else {
        return (
          <div className='subtitle1' onClick={() => editCMS(tab.cms_tab_key)}>
            {cms(tab.cms_tab_key)}{' '}
            <span className='bg-danger ml-2' style={{ padding: '1px 10px', borderRadius: '20px' }}>
              <i class='fa-solid fa-xmark '></i>
            </span>
          </div>
        )
      }
    } else if (progressData?.[tab?.name]?.count_int !== undefined) {
      return (
        <div onClick={() => editCMS(tab.cms_tab_key)} className='subtitle1'>
          {cms(tab.cms_tab_key)}{' '}
          <span className='bg-info ml-2 subtitle1' style={{ padding: '1px 10px', borderRadius: '20px', color: '#fff' }}>
            {progressData?.[tab?.name]?.count_int}
          </span>
        </div>
      )
    } else {
      return (
        <div className='subtitle1' onClick={() => editCMS(tab.cms_tab_key)}>
          {cms(tab.cms_tab_key)}
          {cms(tab.cms_tab_key)?.toLowerCase() === 'logs' && (
            <span className='bg-info ml-2 subtitle1' style={{ padding: '1px 10px', borderRadius: '20px', color: '#fff' }}>
              {logsCount || currentRow?.[0]?.reports_log_count || 0}
            </span>
          )}
        </div>
      )
    }
  } else {
    if (tab?.show_data_progress) {
      if (progressData?.[tab?.name]?.count_int > 0) {
        return (
          <div onClick={() => editCMS(tab.cms_tab_key)} className='subtitle1'>
            {cms(tab.cms_tab_key)}{' '}
            {!window.location.pathname?.includes('email-template') && (
              <span className='bg-success ml-2 subtitle1' style={{ padding: '1px 10px', borderRadius: '20px' }}>
                <i class='fa-solid fa-check '></i>
              </span>
            )}
          </div>
        )
      } else {
        return (
          <div onClick={() => editCMS(tab.cms_tab_key)} className='subtitle1'>
            {cms(tab.cms_tab_key)}{' '}
            {cms(tab.cms_tab_key)?.toLowerCase() === 'logs' && (
              <span className='bg-info ml-2 subtitle1' style={{ padding: '1px 10px', borderRadius: '20px', color: '#fff' }}>
                {logsCount || currentRow?.[0]?.reports_log_count}
              </span>
            )}
            {!window.location.pathname?.includes('email-template') && cms(tab.cms_tab_key)?.toLowerCase() !== 'logs' && (
              <span className='bg-danger ml-2 subtitle1' style={{ padding: '1px 10px', borderRadius: '20px' }}>
                <i class='fa-solid fa-xmark '></i>
              </span>
            )}
          </div>
        )
      }
    } else {
      return <div onClick={() => editCMS(tab.cms_tab_key)}>{cms(tab.cms_tab_key)}</div>
    }
  }
  return (
    <div>
      {cms(tab.cms_tab_key)}{' '}
      <span className='bg-success ml-2' style={{ padding: '1px 10px', borderRadius: '20px' }}>
        <i class='fa-solid fa-check '></i>
      </span>
    </div>
  )
  if (
    progressData &&
    progressData[tab?.name] &&
    progressData[tab?.name]?.count &&
    !progressData[tab?.name]?.count?.includes('undefined') &&
    !tab?.show_count
  ) {
    return tidyName(cms(tab.cms_tab_key)) + ' ' + `${progressData[tab?.name]?.count}`
  } else {
    return tidyName(cms(tab.cms_tab_key))
  }
}

const getTabClassname = (progressData, tab) => {
  if (progressData && progressData[tab?.name] && progressData[tab?.name]?.class && !tab?.show_count) {
    return progressData[tab?.name]?.class
  } else {
    return ''
  }
}

const select = (state) => ({
  editMode: state.CMS.editMode,
  coreData: state.CMS.coreData,
  currentTab: state.Page.currentTab,
  editPageMode: state.CMS.editPageMode,
  selectedDomainId: state.CMS.selected_domain_id,
  domain_id: state.CMS.selected_domain_id,
  userSecurityOverviewDropdown: state.CMS.userSecurityOverviewDropdown,
})

const CMSTabs = ({
  content,
  editMode,
  coreData,
  currentTab,
  pageSize,
  pageName,
  fullPage,
  isModel,
  gridData,
  editPageMode,
  isModalAction,
  addDataDetail,
  setAddDataDetail,
  selectedDomainId,
  domain_id,
  userSecurityOverviewDropdown,
  pageData,
}) => {
  const [tabs, updateTabs] = useState()
  const [activeTab, setActiveTab] = useState(0)
  const page = useSelector((state) => state.CMS.coreData.page)
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const parentTableDataRedux = useSelector((state) => state.CMS.parentTableData)
  const progressData = useSelector((state) => state.CMS.progressData)
  const user = useSelector((state) => state.User.user)
  const dispatch = useDispatch()
  const { state: lockerYearState, updateState: updateLockerYearState } = useLockerYearContext()
  const [logsCount, setLogsCount] = useState(currentRow?.[0]?.reports_log_count || 0)

  const page_data = page?.[pageName]
  const main_table = page_data?.component_call_buttons?.filter((item) => item.component_name === 'hidden_tab')

  const fetechLogsCount = () => {
    request('log-count', 'POST', { row_id: currentRow?.[0]?.uuid, table: main_table?.[0]?.source_table || page_data?.source_table }).then((res) => {
      if (res?.data?.data) {
        setLogsCount(res?.data?.data || logsCount)
      }
    })
  }

  const getTabs = () => {
    return tabs
      ?.filter((item) => {
        if (
          page_data?.template_name === 'locker_years' &&
          ['rates_items', 'codes_items', 'email_email_renewal', 'renewals_renewal_emails', 'go_live_early_domain_item_date_time']?.includes(
            item?.name
          ) &&
          !lockerYearState?.is_block_created
        ) {
          return false
        }
        if (window.location.pathname?.includes('purchase') && !checkIsAdminOrManager(user?.role)) {
          if (
            (item?.default_tab_name?.toLowerCase() === 'move booking' || item?.default_tab_name?.toLowerCase() === 'edit purchase') &&
            (currentRow?.[0]?.past_booking || currentRow?.[0]?.is_code_issued || true)
          ) {
            return false
          }
        }
        if (currentRow?.[0]?.status !== '0000' && item?.default_tab_name?.toLowerCase() === 'move booking') {
          return false
        }
        if (item?.name === 'security_user_groups_user_groups' && currentRow?.[0]?.security_global?.user_groups !== 'deny_except') {
          return false
        }
        return true
      })
      ?.map((tab, index) => {
        return {
          // title: 'Jasmin',
          title: <GetTabTitle progressData={progressData} tab={tab} currentRow={currentRow} logsCount={logsCount} />,
          cmsTabKey: tab.cms_tab_key || index,
          tabClassName: getTabClassname(progressData, tab),
          getContent: () => {
            if (addDataDetail?.activeTabNumber === index && addDataDetail?.open) {
              return (
                <AddGridData
                  addDataDetail={addDataDetail}
                  setAddGridDataDetail={setAddDataDetail}
                  hideTitle={true}
                  clearCurrentRowOnBack={false}
                  key={index}
                  fetechLogsCount={fetechLogsCount}
                />
              )
            }

            if (tab.cms_tab_key === 'nav.all_questions_and_answers' || tab.cms_tab_key === 'nav.all_question_answers') {
              return <ApproveJobsQuestionnaire key={index} />
            }
            if (tab?.source_table === 'permissions' && pageName === 'users') {
              return <UserPermission key={index} />
            }
            if (tab?.source_table?.includes('security_')) {
              return (
                <SecurityTab
                  noTitle={tab.component_name === 'show_tabs_on_load'}
                  hideButtons={tab.component_name === 'show_tabs_on_load'}
                  content={tab.component_call_form}
                  tabName={tab.name}
                  sourceTable={tab.source_table}
                  pageName={tab.name}
                  parentPageName={pageName}
                  fullPage={fullPage}
                  isDatabaseDropdownVisible={fullPage}
                  isModel={isModel}
                  gridData={gridData}
                  hideEditIcon={!isModel}
                  showMore={false}
                  cmsTabKey={tab.cms_tab_key}
                  currentTabData={tab}
                  addDataDetail={addDataDetail}
                  setAddDataDetail={setAddDataDetail}
                  activeTabNumber={activeTab}
                  isTab={true}
                  key={index}
                />
              )
            }
            if (window.location.pathname.includes('school') && tab?.source_table === 'notes') {
              return <NotesTable content={tab.component_call_form} tab={tab}></NotesTable>
            }
            if (window.location.pathname.includes('school') && tab?.source_table === 'voucher_codes') {
              return <VoucherTable tab={tab} content={tab.component_call_form}></VoucherTable>
            }
            if (window.location.pathname.includes('school') && tab?.name?.includes('logs')) {
              return <DomainLogs parentPageName={pageName}></DomainLogs>
            }
            if (tab?.name === 'logs_query_types_update') {
              return <QueryTypeLog parentPageName={pageName} />
            }
            if (tab?.name === 'purchase_purchase') return <EditPurchase></EditPurchase>
            if (tab?.name === 'move_booking_purchase')
              return (
                <MoveBooking
                  redirectToEdit={() => {
                    setActiveTab(1)
                  }}></MoveBooking>
              )
            if (tab?.name === 'logs_purchase') return <RefundLogs parentPageName={pageName}></RefundLogs>
            if (tab?.name === 'logs_item_date_time_update') return <RenewalLogs parentPageName={pageName} />

            return (
              <Tab
                noTitle={tab.component_name === 'show_tabs_on_load'}
                hideButtons={tab.component_name === 'show_tabs_on_load'}
                content={tab.component_call_form}
                tabName={tab.name}
                sourceTable={tab.source_table}
                pageName={tab.name}
                parentPageName={pageName}
                fullPage={fullPage}
                isDatabaseDropdownVisible={fullPage}
                isModel={isModel}
                gridData={gridData}
                hideEditIcon={!isModel}
                showMore={false}
                cmsTabKey={tab.cms_tab_key}
                currentTabData={tab}
                addDataDetail={addDataDetail}
                setAddDataDetail={setAddDataDetail}
                activeTabNumber={activeTab}
                isTab={true}
                key={index}
                pageData={pageData}
                fetechLogsCount={fetechLogsCount}
              />
            )
          },
          disabled: !tab.allowed,
          key: index,
        }
      })
  }

  useEffect(() => {
    if (page_data?.template_name === 'locker_years') {
      updateLockerYearState({
        isLockerYearsPage: true,
      })
    }
    if (currentRow?.[0]?.id && page_data?.template_name === 'locker_years') {
      request('renewal-locations/check-block-status', 'POST', { item_date_time_id: currentRow?.[0]?.id }).then((res) => {
        updateLockerYearState({
          is_block_created: res?.data?.is_block_created,
          is_approve_rate: res?.data?.is_approve_rate,
          is_email_approve: res?.data?.is_email_approve,
        })
      })
    }
  }, [])

  useEffect(() => {
    if (!pageName?.includes('security')) {
      updateTabs(content)
    }
  }, [content, coreData])

  useEffect(() => {
    const currentUserSecurityData = userSecurityOverviewDropdown?.[currentRow?.[currentRow?.length - 1]?.id]

    if (currentUserSecurityData && content?.length > 0) {
      const grantAllFields = []
      Object.keys(currentUserSecurityData)?.map((key) => {
        if (currentUserSecurityData[key] === 'grant_all') {
          grantAllFields?.push(key)
        }

        if (grantAllFields?.length > 0) {
          const filtered_tabs = content?.filter((tab) => {
            if (tab?.source_table === 'users') {
              return true
            }
            if (!grantAllFields?.includes(tab?.source_table?.replace('security_', '') || tab?.source_table === 'users')) {
              return true
            } else {
              return false
            }
          })

          updateTabs(filtered_tabs)
        } else if (pageName?.includes('security')) {
          updateTabs(content)
        }
      })
    } else if (pageName === 'approve_jobs') {
      if (currentRow[currentRow?.length - 1]?.approved) {
        updateTabs(content)
      } else {
        updateTabs(content?.slice(0, 2))
      }
    } else if (pageName?.includes('security')) {
      updateTabs(content)
    }
  }, [userSecurityOverviewDropdown, content, currentRow])

  if (!tabs && tabs?.length === 0) return <div>Content Not found</div>

  //if only single tab, tab name not visible so removed this condition
  if (tabs?.length === 1 || (tabs?.length === 1 && isModel))
    return (
      <Row>
        {!isModel && tabs[0]?.name !== 'draw' && (
          <Col md={12}>
            <PageTitle
              onTitleClick={() => editCMS(tabs?.[0]?.cms_tab_key || tabs?.[0]?.cms_tab_key)}
              heading={cms(tabs?.[0]?.cms_tab_key || tabs?.[0]?.cms_tab_key)}
              icon={tabs?.[0]?.icon}
              component_name={tabs?.[0]?.component_name}
              hideBreadCrumbs
            />
          </Col>
        )}

        {editPageMode && !isModel && (
          <div>
            <SetTabOrder
              tabs={tabs}
              pageName={pageName}
              formName={pageName}
              main_source_table={
                parentTableDataRedux && parentTableDataRedux?.length > 0
                  ? parentTableDataRedux[parentTableDataRedux?.length - 1]?.source_table
                  : main_table && main_table[0]?.source_table
              }
            />
          </div>
        )}

        <div style={{ marginLeft: 'auto' }}>
          {editPageMode && (
            <>
              <AddNewTabOnPage page={page_data} parentPageName={pageName} />
              <span className='verticle-devider'></span>

              <EditTabPage activeTabData={tabs[0]} pageName={tabs[0]?.name} parentPageName={pageName} showTitle gridData={gridData} />
            </>
          )}
          {tabs[0]?.component_call_form?.length === 1 &&
            tabs[0]?.component_call_form?.map((form, key) => {
              return (
                <React.Fragment key={key}>
                  {editPageMode && tabs[0]?.component_name === 'show_tabs_on_load' && (
                    <span className='no-print'>
                      <ConfirmButton
                        color='danger'
                        id={form.name}
                        clickEvent={() =>
                          dispatch(
                            removeItemByName({
                              name: form.name,
                              type: 'form',
                            })
                          )
                        }>
                        <Icon icon={'fas fa-trash'} color='light' /> Remove {cms(form.cms_header_key) || form.name} ({form.component_name})
                      </ConfirmButton>
                    </span>
                  )}
                </React.Fragment>
              )
            })}
        </div>

        <Col md={12}>
          {tabs[0]?.source_table === 'permissions' && (main_table?.[0]?.source_table === 'roles' || !main_table?.[0]?.source_table) ? (
            <Permission parent_source_table={main_table?.[0]?.source_table} />
          ) : (
            <Tab
              noTitle={tabs[0].component_name === 'show_tabs_on_load'}
              hideButtons={tabs[0].component_name === 'show_tabs_on_load'}
              content={tabs[0].component_call_form}
              tabName={tabs[0].name}
              sourceTable={tabs[0].source_table}
              pageName={tabs[0].name}
              parentPageName={pageName}
              fullPage={fullPage}
              isDatabaseDropdownVisible={fullPage}
              isModel={isModel}
              gridData={gridData}
              isModalAction={isModalAction}
              currentTabData={tabs[0]}
              addDataDetail={addDataDetail}
              setAddDataDetail={setAddDataDetail}
              activeTabNumber={0}
              isTab={true}
              pageData={page}
            />
          )}
        </Col>
      </Row>
    )

  const tab_items = getTabs()

  return (
    <>
      <div id='child-page-1'>
        <RCTabs
          items={tab_items}
          selectedTabKey={currentTab || 0}
          activeTab={activeTab}
          onChange={(e) => {
            const ele = document.getElementById('close-btn')
            const saveBtn = document.getElementById('form-save-btn')
            if (saveBtn && window.location.pathname?.includes('schools')) {
              // saveBtn.click()
            }
            dispatch(fetchUpdateApiData())
            if (ele) {
              ele.click()
            }
            setTimeout(() => {
              setActiveTab(parseInt(e))
            }, 500)
          }}
          pageData={pageData}
        />
      </div>

      {/* <Tabs
        selectedTabKey={currentTab || 0}
        tabsWrapperClass={'body-tabs body-tabs-alt edit-page-tab ' + pageSize}
        transform={false}
        showInkBar={true}
        items={getTabs()}
        beforeChange={(e) => handleTabEditCMS(e)}
        onChange={(e) => setActiveTab(e)}
        showMoreIcon={true}
        allowRemove={false}
        // showMoreLabel='More tabs'
      /> */}
    </>
  )
}

export default connect(select)(CMSTabs)
